import { useMutation } from "@tanstack/react-query";
import {
  EngagementBlueprintFormData,
  updateEngagementBlueprint
} from "PFCore/services/admin/engagement_blueprints";
import { Id } from "PFCore/types";

import { mutationKeys } from "./mutation_keys";

export const useEngagementBlueprintUpdate = () =>
  useMutation({
    mutationKey: mutationKeys.update(),
    mutationFn: (formData: EngagementBlueprintFormData & { id: Id }) =>
      updateEngagementBlueprint(formData.id, formData)
  });
